export default __webpack_public_path__ + "static/media/pic7.c1733b79.jpg";